<template>
  <el-dialog @close="closeDialog" :append-to-body="false" :visible.sync="dialogVisible" width="1000px" top="10%">
    <el-form class="flex-item role-form" ref="validateForm" :model="form" :rules="rules" :validate-on-rule-change="false" label-width="160px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="项目名称:" prop="project">
            <el-input v-model="project" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="登录账号:" prop="loginName">
            <el-input v-model="form.loginName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="登录密码:" prop="password">
            <el-input v-model="form.password" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="申报用户真实姓名:" prop="username">
            <el-input v-model="form.username"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申报手机号:" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="申报联系邮箱:" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="验证码:" prop="captcha">
            <el-input v-model="form.captcha" style="width: 60%; vertical-align: top;"></el-input>
            <div @click="getCaptcha" style="display: inline-block; width: 40%;">
              <el-image :src="captchaImg" alt="验证码" style="width: 110px; height: 38px;"></el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flex-item" style="text-align: center">
        <el-button type="primary" :loading="isBtnLoading" @click="handleSignup">提 交</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import {signup, getCaptchaImg} from "@/api/api";
import {checkPhone, checkEmail, checkPassWord, checkLoginName} from "@/assets/js/validator";
import crypto from "crypto";

export default {
  data() {
    return {
      passwordRule: '请输入8到32位密码，同时包含大写字母、小写字母，数字和特殊字符，且不能包含空格',
      captchaImg: "",
      project: '2026年度消费品以旧换新政策',
      isBtnLoading: false,
      dialogVisible: false,
      form: {
        loginName: '',
        password: '',
        username: '',
        phone: '',
        email: '',
        captchaKey: '',
        captcha: ''
      },
      rules: {
        loginName: [{validator: checkLoginName, required: true, trigger: "blur"}],
        password: [{validator: checkPassWord, required: true, trigger: "blur"}],
        username: [{message: "用户姓名不能为空", required: true, trigger: "blur"}],
        phone: [{validator: checkPhone, required: true, trigger: "blur"}],
        email: [{validator: checkEmail, required: true, trigger: "blur"}],
        captcha: [{message: "请输入验证码", required: true, trigger: "blur"}]
      },
    };
  },
  mounted() {
    // this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      getCaptchaImg().then(res => {
        console.log(res.captchaKey)
        this.form.captchaKey = res.captchaKey;
        this.captchaImg = res.captchaImage;
      })
    },
    open() {
      this.dialogVisible = true;
      this.form = {
        loginName: '',
        password: '',
        username: '',
        phone: '',
        email: '',
        captchaKey: '',
        captcha: ''
      };
      // 弹窗打开时再获取验证码
      this.getCaptcha();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.validateForm.clearValidate()
    },
    handleSignup() {
      this.isBtnLoading = true;
      this.$refs["validateForm"].validate((valid) => {
        if (valid) {
          // 登录密码进行加密
          const cipher = crypto.createCipheriv('aes-128-cbc', Buffer.from('9@#hD*8637he%17U'),"RandomInitVector");
          let encrypted = cipher.update(this.form.password, 'utf8', 'base64');
          encrypted += cipher.final('base64');
          let param = {...this.form};
          param.password = encrypted;
          signup(param).then((res) => {
            if (res.code === '200') {
              this.dialogVisible = false;
              this.form = {
                loginName: '',
                password: '',
                username: '',
                phone: '',
                email: '',
                captchaKey: '',
                captcha: ''
              }
              this.$message({
                type: "success",
                message: "注册申请成功",
              });
              this.isBtnLoading = false;
            } else {
              this.getCaptcha();
              this.$message.error(res.message);
              this.isBtnLoading = false;
            }
          }).catch(() => {
            this.getCaptcha();
            this.isBtnLoading = false;
          })
        } else {
          this.isBtnLoading = false;
        }
      });
    },
  },
};
</script>

